import "react-toastify/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.css";
import lodging from "../../images/mapDetails/lodging.png";
import gas_stations from "../../images/mapDetails/gas_stations.png";
import hospitals from "../../images/mapDetails/hospitals.png";
import parks from "../../images/mapDetails/park.png";
import deafult from "../../images/mapDetails/red-dot.png";
import restaurant from "../../images/mapDetails/restaurant.png";
import shopping from "../../images/mapDetails/shopping_mall.png";

export const TransportIcons = ({ style }) => {
  return (
    <svg
      width="54"
      height="24"
      viewBox="0 0 54 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20.5715L0.0976997 0.0183716C0.0976997 0.0183716 45.1897 0.0183941 46.6831 0.0183716C49.4528 7.71433 50.0215 4.00003 50.0215 20.5715C47.7479 20.5715 46.6109 20.5715 45.4739 20.5715C46.895 16.5715 36.6634 12 36.3792 20.5715C32.9925 20.6471 15.3518 20.6039 13.6444 20.5877C15.9159 17.1429 4.54739 11.4286 4.54739 20.5715C3.12634 20.5715 0 20.5715 0 20.5715Z"
        fill="#A5DCF3"
      />
      <path
        d="M46.6284 0.0200806C36.9335 0.0257881 7.38669 0.0377806 8.46959e-06 0.0377806C1.59179e-05 6.79412 -1.38754e-05 14.7815 8.46959e-06 20.5767C1.48433 20.5825 3.05101 20.5767 4.54568 20.5767C4.54568 18.0695 6.5943 16.0125 9.09132 16.0125C11.5884 16.0125 13.637 18.0695 13.637 20.5767C16.5665 20.5767 19.6928 20.5767 22.7283 20.5767C22.7272 14.6772 22.7283 8.78646 22.7283 2.89042C22.7238 2.62418 22.9295 2.36977 23.19 2.31987C24.7303 2.31987 26.294 2.31987 27.8422 2.31987C28.1397 2.31992 28.4104 2.5917 28.4104 2.89042C28.4104 8.79302 28.4104 15.3117 28.4104 20.5769C31.0907 20.5769 33.6943 20.5771 36.3653 20.5769C36.3653 18.0696 38.414 16.0127 40.911 16.0127C43.4081 16.0127 45.4568 18.0696 45.4568 20.5769C47.0205 20.5768 48.4167 20.5769 50.0021 20.5769C50.0021 19.9351 50.0029 19.4064 50.0021 18.8118C48.0015 18.3325 46.876 16.8948 46.078 15.1034C45.932 14.7849 46.1595 14.3566 46.5044 14.3011C47.6492 14.3999 48.832 14.6145 49.9846 14.7825C49.9027 8.38724 49.5046 5.17708 47.6585 1.74949H50.0021C50.9767 1.90901 51.4184 2.52712 51.707 3.37195C51.7067 4.3657 51.707 5.29645 51.707 6.31367C51.704 6.913 52.2463 7.46031 52.8433 7.46031C53.4403 7.46031 53.9825 6.913 53.9799 6.31367V3.46102C53.6957 2.29657 53.2887 2.25792 52.577 2.33757C52.0534 1.37751 50.9648 0.625972 50.0021 0.608159H47.0015C46.8742 0.400102 46.739 0.193477 46.6284 0.0200806ZM2.1663 2.31998C3.70668 2.31998 5.27029 2.31998 6.8185 2.31998C7.11602 2.32003 7.38669 2.59181 7.38669 2.89053V9.73686C7.38665 10.0356 7.11598 10.3073 6.8185 10.3073H2.27284C1.97534 10.3073 1.70468 10.0356 1.70463 9.73686V2.89053C1.70009 2.62429 1.90582 2.36988 2.1663 2.31998ZM8.41657 2.31998C9.95696 2.31998 11.5206 2.31998 13.0688 2.31998C13.3663 2.32003 13.637 2.59181 13.637 2.89053V9.73686C13.637 10.0356 13.3663 10.3073 13.0688 10.3073H8.52312C8.22563 10.3073 7.95496 10.0356 7.95493 9.73686V2.89053C7.95038 2.62429 8.1561 2.36988 8.41657 2.31998ZM14.6669 2.31998C16.9649 2.31941 19.286 2.31998 21.5919 2.31998C21.8894 2.32003 22.1601 2.59181 22.1601 2.89053V9.73686C22.16 10.0356 21.8894 10.3073 21.5919 10.3073H14.7734C14.4759 10.3073 14.2052 10.0356 14.2052 9.73686V2.89053C14.2006 2.62429 14.4064 2.36988 14.6669 2.31998ZM29.4403 2.31998C30.9806 2.31998 32.5442 2.31998 34.0924 2.31998C34.39 2.32003 34.6606 2.59181 34.6607 2.89053V9.73686C34.6606 10.0356 34.3899 10.3073 34.0924 10.3073H29.5468C29.2493 10.3073 28.9786 10.0356 28.9786 9.73686V2.89053C28.974 2.62429 29.1798 2.36988 29.4403 2.31998ZM35.6906 2.31998C37.6096 2.31998 39.5521 2.31998 41.479 2.31998C41.714 2.32569 41.9385 2.48813 42.0119 2.71222C42.556 4.35163 43.7518 6.77548 43.7518 10.8779C43.7459 11.2028 43.4148 11.4815 43.0949 11.4306L35.7083 10.2895C35.4473 10.2478 35.2339 10.0021 35.2289 9.73686V2.89053C35.2243 2.62429 35.43 2.36988 35.6906 2.31998ZM43.0774 2.31998C43.8606 2.31998 44.6657 2.31998 45.4568 2.31998C45.6914 2.32569 45.916 2.48813 45.9893 2.71222C46.5334 4.35163 47.7292 6.7891 47.7292 11.4484C47.7296 11.7952 47.3539 12.0878 47.0191 12.0011L44.7462 11.4306C44.5045 11.368 44.3201 11.1287 44.3201 10.8779C44.3201 9.29305 43.7757 6.45587 42.651 3.06878C42.5437 2.76127 42.7586 2.38307 43.0774 2.31998ZM15.3416 3.46102V5.74315H17.6144V3.46102H15.3416ZM18.7509 3.46102V5.74315H21.0237V3.46102H18.7509ZM23.8647 10.3073V20.5769H27.2739V10.3073H23.8647ZM47.6939 15.6025C48.1668 16.6088 49.0033 17.3503 50.0021 17.5816C50.0025 17.0403 50.0017 16.4194 50.0021 15.9235L47.6939 15.6025ZM9.09132 17.1537C7.20842 17.1537 5.68207 18.6862 5.68207 20.5769C5.68207 22.4674 7.20842 24 9.09132 24C10.9742 24 12.5006 22.4674 12.5006 20.5769C12.5006 18.6862 10.9742 17.1537 9.09132 17.1537ZM40.911 17.1537C39.0281 17.1537 37.5016 18.6862 37.5016 20.5769C37.5016 22.4674 39.0281 24 40.911 24C42.794 24 44.3201 22.4674 44.3201 20.5769C44.3201 18.6862 42.794 17.1537 40.911 17.1537Z"
        fill={`${style.color}`}
      />
      <path
        d="M46.6497 0.00524259C44.7574 -0.00164616 38.0502 -0.00655866 34.7134 0.0229426C34.6681 2.42464 34.6233 2.75875 34.6904 8.74508V20.5714C34.9588 20.5714 35.5272 20.5714 36.3798 20.5714C36.3798 18.0642 38.4349 15.9978 40.932 15.9978C43.429 15.9978 45.4747 18.0642 45.4747 20.5714C47.0385 20.5714 48.438 20.5621 50.0234 20.5621C50.0234 19.9203 50.0238 19.3916 50.0234 18.797C48.0228 18.3177 46.897 16.88 46.0992 15.0885C45.9529 14.7701 46.1804 14.3418 46.5253 14.2863C47.6705 14.3851 48.8529 14.5997 50.0055 14.7677C49.924 8.3724 49.5258 5.16225 47.6794 1.73465H50.0234C50.9976 1.89417 51.4397 2.51228 51.7279 3.35712C51.7279 4.35086 51.7279 5.28161 51.7279 6.29884C51.7253 6.89816 52.2676 7.44548 52.8646 7.44548C53.4612 7.44548 54.0038 6.89816 54.0008 6.29884V3.44619C53.7166 2.28173 53.3096 2.24308 52.5979 2.32273C52.0747 1.36268 50.9861 0.611134 50.0234 0.593321H47.0225C46.8951 0.385268 46.7603 0.178643 46.6497 0.00524259ZM35.7117 2.30514C37.6309 2.30514 39.5734 2.30514 41.5003 2.30514C41.7353 2.31085 41.9595 2.47329 42.0328 2.69738C42.5773 4.3368 43.7731 6.76065 43.7731 10.8631C43.7672 11.188 43.4357 11.4666 43.1162 11.4158L35.7294 10.2747C35.4685 10.233 35.2551 9.98726 35.25 9.72203V2.87569C35.2455 2.60946 35.4512 2.35505 35.7117 2.30514ZM43.0983 2.30514C43.8815 2.30514 44.6867 2.30514 45.4777 2.30514C45.7127 2.31085 45.9369 2.47329 46.0106 2.69738C46.5547 4.3368 47.7505 6.77426 47.7505 11.4336C47.7509 11.7804 47.3748 12.073 47.0403 11.9863L44.7675 11.4158C44.5258 11.3531 44.3411 11.1138 44.3414 10.8631C44.3414 9.27821 43.7966 6.44104 42.6723 3.05394C42.5646 2.74643 42.7799 2.36823 43.0983 2.30514ZM47.7152 15.5877C48.1881 16.5939 49.0246 17.3354 50.0234 17.5668C50.0238 17.0255 50.023 16.4045 50.0234 15.9087L47.7152 15.5877Z"
        fill="black"
      />
      <path
        d="M40.7801 24C43.0146 24 44.3181 22.405 44.3181 20.4375C44.3181 18.47 42.7341 16.875 40.7801 16.875C38.8262 16.875 37.2422 18.47 37.2422 20.4375C37.2422 22.405 38.8262 24 40.7801 24Z"
        fill="black"
      />
      <path
        d="M9.12389 24C11.0779 24 12.6618 22.405 12.6618 20.4375C12.6618 18.47 11.0779 16.875 9.12389 16.875C7.16993 16.875 5.58594 18.47 5.58594 20.4375C5.58594 22.405 7.16993 24 9.12389 24Z"
        fill="black"
      />
      <path
        d="M40.783 22.5625C41.9144 22.5625 42.8316 21.6251 42.8316 20.4687C42.8316 19.3124 41.9144 18.375 40.783 18.375C39.6516 18.375 38.7344 19.3124 38.7344 20.4687C38.7344 21.6251 39.6516 22.5625 40.783 22.5625Z"
        fill="#A5DCF3"
      />
      <path
        d="M9.12674 22.5625C10.2582 22.5625 11.1754 21.6251 11.1754 20.4687C11.1754 19.3124 10.2582 18.375 9.12674 18.375C7.99532 18.375 7.07812 19.3124 7.07812 20.4687C7.07812 21.6251 7.99532 22.5625 9.12674 22.5625Z"
        fill="#A5DCF3"
      />
    </svg>
  );
};

export const getPlaceConfig = (mapDetail) => {
  const defaultIcon = "https://maps.google.com/mapfiles/ms/icons/red-dot.png";

  const config = {
    HOTELS: {
      type: "lodging",
      // icon: "https://maps.google.com/mapfiles/kml/shapes/lodging.png",
      icon: lodging,
      fallbackIcon: defaultIcon,
    },
    RESTAURANTS: {
      type: "restaurant",
      // icon: "https://maps.google.com/mapfiles/kml/shapes/dining.png",
      icon: restaurant,
      fallbackIcon: defaultIcon,
    },
    HOSPITALS: {
      type: "hospital",
      icon: hospitals,
      fallbackIcon: defaultIcon,
    },
    STREET_NAMES: {
      type: null, // This is a map style, not a place type
      icon: null,
      fallbackIcon: null,
    },
    SHOPPING_MALLS: {
      type: "shopping_mall",
      // icon: "https://maps.google.com/mapfiles/kml/shapes/shopping.png",
      icon: shopping,
      fallbackIcon: defaultIcon,
    },
    PARK_NAMES: {
      type: "park",
      // icon: "https://maps.google.com/mapfiles/kml/shapes/parks.png",
      icon: parks,
      fallbackIcon: defaultIcon,
    },
    PETROL_PUMPS: {
      type: "gas_station",
      icon: gas_stations,
      fallbackIcon: defaultIcon,
    },
  };

  return config[mapDetail] || null;
};

export const containerStyle = {
  border: "1px solid #183059",
  padding: "40px",
  height: "540px",
  width: "100%",
  borderRadius: "8px",
};

export const containerStyleForURL = {
  border: "1px solid #183059",
  padding: "40px",
  height: "100vh",
  width: "100%",
};

export const colors = [
  "#20A8E0",
  "#8FBC8F",
  "#FFD700",
  "#6495ED",
  "#FF69B4",
  "#FFA07A",
  "#ADFF2F",
  "#FF4500",
  "#9370DB",
  "#FFFFFF",
];

export const mapStyles = [
  {
    featureType: "all",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ visibility: "on" }, { color: "black" }],
  },
];

export const isValidMapCombination = (mapView, mapLayers) => {
  const invalidCombinations = {
    SATELLITE: ["TRAFFIC", "TRANSIT", "BICYCLING"],
    TERRAIN: ["TRAFFIC", "TRANSIT"],
    HYBRID: ["TRAFFIC", "TRANSIT", "BICYCLING"],
  };

  return !invalidCombinations[mapView]?.includes(mapLayers);
};

export const normalizeMapView = (mapview) => {
  const normalized = mapview?.toUpperCase();
  switch (normalized) {
    case "SATELLITE":
      return "satellite";
    case "ROADMAP":
    case "STANDARD":
      return "roadmap";
    case "HYBRID":
      return "hybrid";
    case "TERRAIN":
      return "terrain";
    default:
      console.warn(`Invalid mapview: ${mapview}, defaulting to roadmap`);
      return "roadmap";
  }
};
